import styled from 'styled-components';

const SELECTORS = '.app_uplay .pt_content #primary, ';
const TABLET_BREAKPOINT = '1280px';
const MIN_PRICE_BANNER_SIZE = '850px';

export const PriceBannerBlockContainer = styled.div`
    ${SELECTORS} & {
      margin-top: 100px;
      position: relative;
    }
    @media (max-width: ${TABLET_BREAKPOINT}) 
    {
        ${SELECTORS} & {
            max-height: 460px;
            overflow: hidden;
        }
    }
`;

export const SubscriptionPriceContainer = styled.div`
    ${SELECTORS} & {
      p{
      color: white;
      text-align: center;
      }
    }
`;

export const PriceBannerImageContainer = styled.div`
    ${SELECTORS} & {
        display: inline-block;
        width: 100%;
        height: auto;
        margin: auto;
        img{
          max-width: unset;
          width: 100%;
        }
    }
`;

export const PriceBannerInformationContainer = styled.div`
    ${SELECTORS} & {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    @media (max-width: ${MIN_PRICE_BANNER_SIZE}) { 
        ${SELECTORS} & {
             width: 70%;
        }
    }
`;

export const UbisoftPlusLogoContainer = styled.div`
    ${SELECTORS} & {
        width: fit-content;
        margin: auto;
      svg{
        display: inline-block;
        width: 349px;
        height: 66px;
      }
    }
    
    @media (max-width: ${TABLET_BREAKPOINT}) {
        ${SELECTORS} & {
          svg{
            width: 262px;
            height: 43px;
          }
         }
      }
      
      @media (max-width: ${MIN_PRICE_BANNER_SIZE}) {
        ${SELECTORS} & {
            svg{
                width: 192px;
                height: 31px;
            }
        }  
   }   
`;

export const PriceBannerDescription = styled.p`
    ${SELECTORS} & {
      font-size: 32px;
      line-height: 36px;
      text-align: center;
      font-family: "Ubisoft Sans Regular",Arial,sans-serif;
      margin-bottom: 30px;
      color: white;
    }
    @media (max-width: ${TABLET_BREAKPOINT}) {
        ${SELECTORS} & {
            font-size: 16px;
            line-height: 19.2px;
            margin-bottom: 20px;
        }
    }
    @media (max-width: ${MIN_PRICE_BANNER_SIZE}) { 
        ${SELECTORS} & {
            margin-bottom: 10px;
        }
    }
    
    
`;

export const PrinceTextContainer = styled.div`
    ${SELECTORS} & {
        display: flex;
        justify-content: center;
        align-items: baseline;
        margin-bottom: 20px;
    }
`;

export const SubscriptionPriceText = styled.p`
    ${SELECTORS} & {
      font-size: 50px;
      line-height: 50px;
      font-family: "Ubisoft Sans Regular",Arial,sans-serif;
      margin-bottom: 0;
    }
    
    @media (max-width: ${TABLET_BREAKPOINT}) {
        ${SELECTORS} & {
            font-size: 30px;
         }
    }
`;

export const PriceMonthText = styled.p`
    ${SELECTORS} & {
      font-size: 30px;
      text-align: center;
      color: white;
      font-family: "Ubisoft Sans Regular",Arial,sans-serif;
      line-height: 45px;
      margin-bottom: 2px;
    }
    @media (max-width: ${TABLET_BREAKPOINT}) {
        ${SELECTORS} & {
            font-size: 20px;
            line-height: 24px;
        }
   }
`;

export const PriceBannerSubscriptionButton = styled.div`
    ${SELECTORS} & {
        margin: auto;
        width: fit-content;
    }
    @media (max-width: ${TABLET_BREAKPOINT}) { 
        ${SELECTORS} & {
            margin: auto;
            width: 100%;
            #restriction-info{
                width: 100%;
            }
        }
    }
`;